import { ALIGN_TYPES, VALUE_TYPES as THVT } from "../../../configs/TableHeaderConstants";
import VALUE_TYPES from "../../../configs/ValueTypeConstants";
import * as Yup from 'yup';

export const VOUCHER_TABLE_HEADS = [
    { id: 'voucher_no', label: 'Voucher No', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT },
    { id: 'voucher_date', label: 'Voucher Date', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.DATE },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.EDIT },
]

const PAYMENT_VOUCHER_STATE = {
    voucher_no: null,
    voucher_date: null,
    credit_ledger_id: null,
    credit_amount: 0,
    other_ref: null
};

const PAYMENT_VOUCHER_SCHEMA = Yup.object().shape({
    voucher_no: Yup.string().nullable(),
    voucher_date: Yup.date().required(),
    credit_ledger_id: Yup.number().required(),
    credit_amount: Yup.number().nullable(),
    other_ref: Yup.string().nullable()
});

const PAYMENT_VOUCHER_FORM_FIELDS = [
    { name: "voucher_no", title: "Payment Voucher (PV) No", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "voucher_date", title: "PV Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "credit_ledger_id", title: "Credit Ledger", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "credit_amount", title: "Credit Amount (AED)", required: false, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "other_ref", title: "Other Ref", required: false, type: VALUE_TYPES.TEXT },
];

const JOURNAL_VOUCHER_STATE = {
    voucher_no: null,
    voucher_date: null,
};

const JOURNAL_VOUCHER_SCHEMA = Yup.object().shape({
    voucher_no: Yup.string().nullable(),
    voucher_date: Yup.date().required(),
});

const JOURNAL_VOUCHER_FORM_FIELDS = [
    { name: "voucher_no", title: "JV Number", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "voucher_date", title: "JV Date", required: true, type: VALUE_TYPES.DATEPICKER },
];

const PREPAYMENT_VOUCHER_STATE = {
    voucher_no: null,
    voucher_date: null,
};

const PREPAYMENT_VOUCHER_SCHEMA = Yup.object().shape({
    voucher_no: Yup.string().nullable(),
    voucher_date: Yup.date().required(),
});

const PREPAYMENT_VOUCHER_FORM_FIELDS = [
    { name: "voucher_no", title: "PPY Number", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "voucher_date", title: "PPY Date", required: true, type: VALUE_TYPES.DATEPICKER },
];


const PDC_BANK_PAYMENT_STATE = {
    voucher_no: null,
    voucher_date: null,
    credit_ledger_id: null,
    credit_amount: 0,
    other_ref: null
};

const PDC_BANK_PAYMENT_SCHEMA = Yup.object().shape({
    voucher_no: Yup.string().nullable(),
    voucher_date: Yup.date().required(),
    credit_ledger_id: Yup.number().required(),
    credit_amount: Yup.number().nullable(),
    other_ref: Yup.string().nullable()
});

const PDC_BANK_PAYMENT_FORM_FIELDS = [
    { name: "voucher_no", title: "Payment Voucher (PD) No", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "voucher_date", title: "Voucher Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "credit_ledger_id", title: "Through (Cr)", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "credit_amount", title: "Amount (Cr)", required: false, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "other_ref", title: "Other Ref", required: false, type: VALUE_TYPES.TEXT },
];


export const voucherTypeList = [{
    "name": "Payment Voucher",
    "title": "Payment Vouchers",
},
{
    "name": "Journal Voucher",
    "title": "Journal Vouchers",
},
{
    "name": "Prepayment Voucher",
    "title": "Prepayment Vouchers",
},
{
    "name": "PDC Bank Payment",
    "title": "PDC Bank Payment",
}];

const PAYMENT_VOUCHER_LINE_TABLE_HEADS = [
    { id: 'debit_ledger_code', label: 'A/c Code', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 150 },
    { id: 'debit_ledger_name', label: 'Debit Ledger', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 250 },
    { id: 'cheque_no_or_ref', label: 'Chq No/Ref', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 150 },
    { id: 'cheque_date', label: 'Chq Dt', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.DATE, width: 200 },
    { id: 'cheque_type', label: 'Chq Type', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 120 },
    { id: 'mode_of_pay', label: 'Mode', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 150 },
    { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 300 },
    { id: 'debit_amount', label: 'Debit Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER, width: 150 },
    { id: 'icon_btns', label: 'Edit / Delete', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.ICONBTNS, buttons: ["edit", "delete"], width: 100 },
];

const JOURNAL_VOUCHER_LINE_TABLE_HEADS = [
    { id: 'account_code', label: 'A/C Code', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 150 },
    { id: 'account_name', label: 'Account Name', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 200 },
    { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 500 },
    { id: 'debit_amount', label: 'Debit Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER, width: 150 },
    { id: 'credit_amount', label: 'Credit Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER, width: 150 },
    { id: 'icon_btns', label: 'Edit / Delete', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.ICONBTNS, buttons: ["edit", "delete"], width: 100 },
];

const SPLITUP_VOUCHER_LINE_TABLE_HEADS = [
    { id: 'debit_ledger_name', label: 'Debit Account', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 200 },
    { id: 'credit_ledger_name', label: 'Credit Account', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 200 },
    { id: 'start_date', label: 'SD', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.DATE, width: 300 },
    { id: 'end_date', label: 'ED', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.DATE, width: 300 },
    { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 400 },
    { id: 'debit_amount', label: 'Prepaid Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER, width: 150 },
    { id: 'icon_btns', label: 'Edit / Delete', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.ICONBTNS, buttons: ["edit", "delete"] },
];

export const SPLITUP_LINES_TABLE_HEADS = [
    { id: 'journal_date', label: 'PPY DATE', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.DATE },
    { id: 'debit_ledger_name', label: 'Recurring Account (DEBIT)', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT },
    { id: 'credit_ledger_name', label: 'Prepaid Account (CREDIT)', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT },
    { id: 'debit_amount', label: 'DEBIT AMOUNT', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER },
    { id: 'credit_amount', label: 'CREDIT AMOUNT', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER },
    { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT },
];

const PDC_BANK_PAYMENT_LINE_TABLE_HEADS = [
    { id: 'debit_ledger_name', label: 'Account Name (Dr)', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 200 },
    { id: 'debit_ledger_code', label: 'A/c Code', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 150 },
    { id: 'cheque_no_or_ref', label: 'Chq No/Ref', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 150 },
    { id: 'cheque_date', label: 'Chq Dt', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.DATE, width: 250 },
    { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 400 },
    { id: 'debit_amount', label: 'Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER, width: 150 },
    { id: 'icon_btns', label: 'Delete', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.ICONBTNS, buttons: ["delete"] },
];

export const voucherTypes = {
    "Payment Voucher": {
        "name": "Payment Voucher",
        "title": "Payment Vouchers",
        "schema": PAYMENT_VOUCHER_SCHEMA,
        "state": PAYMENT_VOUCHER_STATE,
        "formFields": PAYMENT_VOUCHER_FORM_FIELDS,
        "tableHeaders": PAYMENT_VOUCHER_LINE_TABLE_HEADS

    },
    "Journal Voucher": {
        "name": "Journal Voucher",
        "title": "Journal Vouchers",
        "schema": JOURNAL_VOUCHER_SCHEMA,
        "state": JOURNAL_VOUCHER_STATE,
        "formFields": JOURNAL_VOUCHER_FORM_FIELDS,
        "tableHeaders": JOURNAL_VOUCHER_LINE_TABLE_HEADS
    },
    "Prepayment Voucher": {
        "name": "Prepayment Voucher",
        "title": "Prepayment Vouchers",
        "schema": PREPAYMENT_VOUCHER_SCHEMA,
        "state": PREPAYMENT_VOUCHER_STATE,
        "formFields": PREPAYMENT_VOUCHER_FORM_FIELDS,
        "tableHeaders": JOURNAL_VOUCHER_LINE_TABLE_HEADS
    },
    "SplitUp": {
        "name": "Prepayment Voucher",
        "title": "Prepayment Vouchers",
        "schema": PREPAYMENT_VOUCHER_SCHEMA,
        "state": PREPAYMENT_VOUCHER_STATE,
        "formFields": PREPAYMENT_VOUCHER_FORM_FIELDS,
        "tableHeaders": SPLITUP_VOUCHER_LINE_TABLE_HEADS
    },
    "SplitUp Lines": {
        "name": "Prepayment Voucher",
        "title": "Prepayment Vouchers",
        "schema": PREPAYMENT_VOUCHER_SCHEMA,
        "state": PREPAYMENT_VOUCHER_STATE,
        "formFields": PREPAYMENT_VOUCHER_FORM_FIELDS,
        "tableHeaders": SPLITUP_LINES_TABLE_HEADS
    },
    "PDC Bank Payment": {
        "name": "PDC Bank Payment",
        "title": "PDC Bank Payments",
        "schema": PDC_BANK_PAYMENT_SCHEMA,
        "state": PDC_BANK_PAYMENT_STATE,
        "formFields": PDC_BANK_PAYMENT_FORM_FIELDS,
        "tableHeaders": PDC_BANK_PAYMENT_LINE_TABLE_HEADS
    }
};

const PAYMENT_VOUCHER_LINE_STATE = {
    debit_ledger_id: null,
    cheque_no_or_ref: null,
    cheque_date: null,
    cheque_type: null,
    mode_of_pay_id: null,
    narration: null,
    debit_amount: null,
};

const PAYMENT_VOUCHER_LINE_SCHEMA = Yup.object().shape({
    debit_ledger_id: Yup.number().required(),
    cheque_no_or_ref: Yup.string().required(),
    cheque_date: Yup.date().required(),
    cheque_type: Yup.string().required(),
    mode_of_pay_id: Yup.number().required(),
    narration: Yup.string().required(),
    debit_amount: Yup.number().required(),
});

const PAYMENT_VOUCHER_LINE_FORM_FIELDS = [
    { name: "debit_ledger_id", title: "A/c Code", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id", colSpan: 2 },
    { name: "cheque_no_or_ref", title: "Chq No / Ref", required: true, type: VALUE_TYPES.TEXT },
    { name: "cheque_date", title: "Chq Dt", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "cheque_type", title: "Chq Type", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "code", disabled: false },
    { name: "mode_of_pay_id", title: "Mode", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "mode_of_pay", itemValue: "id" },
    { name: "narration", title: "Narration", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "debit_amount", title: "Debit Amt", required: true, type: VALUE_TYPES.DECIAML },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },
];

const JOURNAL_VOUCHER_LINE_STATE = {
    account_id: null,
    narration: null,
    debit_amount: null,
    credit_amount: null,
};

const JOURNAL_VOUCHER_LINE_SCHEMA = Yup.object().shape({
    account_id: Yup.number().required(),
    narration: Yup.string().required(),
    debit_amount: Yup.number().nullable(),
    credit_amount: Yup.number().nullable(),

});

const JOURNAL_VOUCHER_LINE_FORM_FIELDS = [
    { name: "account_id", title: "A/c Code", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id", colSpan: 2 },
    { name: "narration", title: "Narration", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "debit_amount", title: "Debit Amount (AED)", required: false, type: VALUE_TYPES.DECIAML },
    { name: "credit_amount", title: "Credit Amount (AED)", required: false, type: VALUE_TYPES.DECIAML },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },
];

const PREPAYMENT_VOUCHER_LINE_STATE = {
    debit_ledger_id: null,
    narration: null,
    debit_amount: null,
    credit_amount: null,
};

const PREPAYMENT_VOUCHER_LINE_SCHEMA = Yup.object().shape({
    debit_ledger_id: Yup.number().required(),
    narration: Yup.string().required(),
    debit_amount: Yup.number().nullable(),
    credit_amount: Yup.number().nullable(),
});

const PREPAYMENT_VOUCHER_LINE_FORM_FIELDS = [
    { name: "debit_ledger_id", title: "A/c Code", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id", colSpan: 2 },
    { name: "narration", title: "Narration", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "debit_amount", title: "Debit Amount (AED)", required: false, type: VALUE_TYPES.DECIAML },
    { name: "credit_amount", title: "Credit Amount (AED)", required: false, type: VALUE_TYPES.DECIAML },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },
];

export const PREPAYMENT_SPLITUP_VOUCHER_LINE_STATE = {
    type: "SplitUp",
    debit_ledger_id: null,
    credit_ledger_id: null,
    narration: null,
    debit_amount: null,
    start_date: null,
    end_date: null
};

export const PREPAYMENT_SPLITUP_VOUCHER_LINE_SCHEMA = Yup.object().shape({
    debit_ledger_id: Yup.number().required(),
    credit_ledger_id: Yup.number().required(),
    narration: Yup.string().required(),
    debit_amount: Yup.number().required(),
    start_date: Yup.date().required(),
    end_date: Yup.date().required(),
});

export const PREPAYMENT_SPLITUP_VOUCHER_LINE_FORM_FIELDS = [
    { name: "debit_ledger_id", title: "A/c Code - Debit Ledger", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "credit_ledger_id", title: "A/C Code - Credit Ledger ", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "start_date", title: "Start Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "end_date", title: "End Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "narration", title: "Narration", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "debit_amount", title: "Prepaid Amount", required: true, type: VALUE_TYPES.DECIAML },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },
];


const PDC_BANK_PAYMENT_LINE_STATE = {
    debit_ledger_id: null,
    cheque_no_or_ref: null,
    cheque_date: null,
    narration: null,
    debit_amount: 0,
};

const PDC_BANK_PAYMENT_LINE_SCHEMA = Yup.object().shape({
    debit_ledger_id: Yup.number().required(),
    cheque_no_or_ref: Yup.string().nullable(),
    cheque_date: Yup.date().nullable(),
    narration: Yup.string().required(),
    debit_amount: Yup.number().required(),
});

const PDC_BANK_PAYMENT_LINE_FORM_FIELDS = [
    { name: "debit_ledger_id", title: "A/c Code", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id", colSpan: 2 },
    { name: "cheque_no_or_ref", title: "Chq No / Ref", required: false, type: VALUE_TYPES.TEXT },
    { name: "cheque_date", title: "Chq Dt", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "narration", title: "Narration", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "debit_amount", title: "Debit Amt", required: true, type: VALUE_TYPES.DECIAML },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },
];

export const voucherLineTypes = {
    "Payment Voucher": {
        "name": "Payment Voucher Line",
        "title": "Payment Vouchers",
        "schema": PAYMENT_VOUCHER_LINE_SCHEMA,
        "state": PAYMENT_VOUCHER_LINE_STATE,
        "formFields": PAYMENT_VOUCHER_LINE_FORM_FIELDS,
    },
    "Journal Voucher": {
        "name": "Journal Voucher Line",
        "title": "Journal Vouchers",
        "schema": JOURNAL_VOUCHER_LINE_SCHEMA,
        "state": JOURNAL_VOUCHER_LINE_STATE,
        "formFields": JOURNAL_VOUCHER_LINE_FORM_FIELDS,
    },
    "Prepayment Voucher": {
        "name": "Prepayment Voucher Line",
        "title": "Prepayment Vouchers",
        "schema": PREPAYMENT_VOUCHER_LINE_SCHEMA,
        "state": PREPAYMENT_VOUCHER_LINE_STATE,
        "formFields": PREPAYMENT_VOUCHER_LINE_FORM_FIELDS,
    },
    "SplitUp": {
        "name": "SplitUp",
        "title": "SplitUp Lines",
        "schema": PREPAYMENT_SPLITUP_VOUCHER_LINE_SCHEMA,
        "state": PREPAYMENT_SPLITUP_VOUCHER_LINE_STATE,
        "formFields": PREPAYMENT_SPLITUP_VOUCHER_LINE_FORM_FIELDS,
        "tableHeaders": JOURNAL_VOUCHER_LINE_TABLE_HEADS
    },
    "SplitUp Lines": {
        "name": "SplitUp Lines",
        "title": "SplitUp Lines",
        "schema": PREPAYMENT_SPLITUP_VOUCHER_LINE_SCHEMA,
        "state": {},
        "formFields": PREPAYMENT_SPLITUP_VOUCHER_LINE_FORM_FIELDS,
        "tableHeaders": JOURNAL_VOUCHER_LINE_TABLE_HEADS
    },
    "PDC Bank Payment": {
        "name": "PDC Bank Payment Line",
        "title": "PDC Bank Payments",
        "schema": PDC_BANK_PAYMENT_LINE_SCHEMA,
        "state": PDC_BANK_PAYMENT_LINE_STATE,
        "formFields": PDC_BANK_PAYMENT_LINE_FORM_FIELDS,
    },
};

const filterState = {
    from_date: null,
    to_date: null
};
const filterSchema = Yup.object().shape({
    from_date: Yup.date().nullable(),
    to_date: Yup.date().nullable(),
});

const filterFormFields = [
    { name: "from_date", title: "From Date", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "to_date", title: "To Date", required: false, type: VALUE_TYPES.DATEPICKER },
];

export const filter = {
    state: filterState,
    schema: filterSchema,
    formFields: filterFormFields
}
